module.exports = __webpack_public_path__ + "static/media/import2.99f5785e.svg";